import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    qtyChart: null,
    table: null,
    dashboard: null,
    busy: false,
  },
  modules: {},
  mutations: {
    set(state, data) {
      state.qtyChart = data.charts?.qty ?? null
      state.dashboard = data.dashboard
      state.table = data.table
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    chart({ qtyChart }, rootState, getters, { 'analysis/colors/courseRanking': { first } }) {
      if (qtyChart === null) {
        return null
      }

      let [columns, ...rows] = qtyChart
      columns = [...columns, { type: 'string', role: 'annotation' }, { role: 'style' }]
      rows = rows.map(([rank, value]) => [rank, value, value, null])

      // 先頭だけ色を変える
      rows[0][3] = first
      return [columns, ...rows]
    },
    dashboardChart({ qtyChart }, rootState, getters, { 'analysis/colors/chartBox': { first } }) {
      if (qtyChart === null) {
        return null
      }

      let [columns, ...rows] = qtyChart
      columns = [...columns, { type: 'string', role: 'annotation' }, { role: 'style' }]
      rows = rows.map(([rank, value]) => [rank, value, value, null])

      // 先頭だけ色を変える
      rows[0][3] = first
      return [columns, ...rows]
    },
    viewWindowMaxValue({ qtyChart }) {
      if (qtyChart === null) {
        return 0
      }
      const rate = 1 + String(qtyChart[1][1]).length * 0.06
      // 1位の文字がチャートのエリアの外に書き出されて表示されないため、表示枠を明示的に拡張する。
      return qtyChart[1][1] < 10 ? 10 : qtyChart[1][1] * rate
    },
    header(state) {
      return state.table?.header ?? null
    },
    data(state) {
      return state.table?.value ?? []
    },
    detail({ qtyChart, dashboard }) {
      return {
        number: qtyChart?.[1]?.[1] ?? null,
        name: qtyChart?.[1]?.[0] ?? null,
        fluctuationType: dashboard?.mom?.fluctuationType ?? null,
        fluctuationValue: dashboard?.mom?.fluctuationValue ?? null,
      }
    },
  },
  actions: {
    async get({ commit, state }, { endTerm, dashboardFlg }) {
      if (state.busy) return
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/analysis/reservation/courseranking', {
        unit: 4,
        endTerm,
        dashboardFlg: dashboardFlg || 0,
      })

      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
  },
}
